<template>
  <div class="flex flex-col gap-3">
    <div class="w-full">
      <label class="vs-input--label"><b> Clearing Date</b></label>
      <datepicker
        class="w-1/3"
        v-validate="'required'"
        :inline="false"
        name="Clearing Date"
        v-model="postingDate"
        placeholder="Clearing Date"
        disabled
      ></datepicker>
      <br/>
      <span>
        <h4 class="mb-5">CN Temporary Item</h4>
      </span>
      <vs-table :data="mappingData">
        <template slot="thead">
          <vs-th> CN Temporary Code </vs-th>
          <vs-th> Invoice Code </vs-th>
          <vs-th> Invoice Note </vs-th>
          <vs-th> Invoice Reason </vs-th>
          <vs-th> Payment Code </vs-th>
          <vs-th> Clearing Value </vs-th>
          <vs-th> Used CN Code </vs-th>
          <vs-th> Used CN Type </vs-th>
          <vs-th> Used Coa </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, indextr) in data" :key="indextr">
            <vs-td> {{ tr.cn_temp_code }} </vs-td>
            <vs-td> {{ tr.invoice_code }} </vs-td>
            <vs-td> {{ tr.invoice_note }} </vs-td>
            <vs-td> {{ tr.invoice_reason }} </vs-td>
            <vs-td> {{ tr.payment_code }} </vs-td>
            <vs-td> {{ tr.clearing_value }} </vs-td>
            <vs-td> {{ tr.used_code }} </vs-td>
            <vs-td> {{ tr.used_type }} </vs-td>
            <vs-td> {{ tr.coa_code }} </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <div class="flex gap-3 w-full justify-end">
      <vs-button color="danger" @click="closeMapping">Close</vs-button>
      <vs-button color="success" @click="handleClearing">Clearing</vs-button>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
    components: {
      Datepicker,
    },
    props: {
      mappingData: {
        type: Array,
        default: () => [],
      },
      postingDate: {
        type: Date,
        default: () => null,
      },
    },
    watch: {},
    data() {
      return {}
    },
    computed: {},
    mounted() {
      console.log(this.mappingData);
      this.processMapping();
    },
    methods: {
      closeMapping() {
        this.$emit("closeMapping");
      },
      closePrompt() {
        this.$emit("closeMapping");
        this.$emit("closePrompt");
      },
      processMapping() {
        console.log("ini jalan");
      },
      handleClearing() {
        this.$vs.loading();
        this.$http
          .patch("api/v1/credit-note/temporary/clearing/v2", {
            mapping_data: this.mappingData,
            clearing_date: this.postingDate,
          })
          .then((response) => {
            if (response.code < 299) {
              this.$vs.notify({
                title: "Success",
                text: "Credit note has been cleared",
                color: "success",
                iconPack: "feather",
                icon: "icon-alert-circle",
                position: "top-right",
              });
              this.closePrompt();
            } else {
              this.$vs.notify({
                title: "Error",
                text: response.message,
                color: "danger",
                iconPack: "feather",
                icon: "icon-alert-circle",
                position: "top-right",
              });
            }
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log(error);
          });
      },
    },
}
</script>